module.exports = __webpack_public_path__ + "static/media/12.0adbf1bb.png";